import {Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {TagEditDialogComponent} from './tag-edit-dialog.component';
import {TagsGridComponent} from './grid/tags-grid.component';
import {RolesEnum} from '../core/security/roles.enum';
import {AuthService} from '../core/security/auth.service';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-tags-grid-dialog',
    template: `
      <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
          <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
              <div fxFlex>Manage Tags</div>
              <button mat-icon-button [mat-dialog-close]="false" class="button-40">
                  <mat-icon>close</mat-icon>
              </button>
          </h1>
          <mat-dialog-content class="mat-typography" fxFlex>
              <app-tags-grid #tagsGrid></app-tags-grid>
          </mat-dialog-content>
          <mat-dialog-actions align="end">
              <button mat-flat-button color="primary" *ngIf="hasEditAccess" (click)="onNewTag()">+ Add Tag</button>
          </mat-dialog-actions>
      </div>
  `,
    styles: [],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, TagsGridComponent, MatDialogActions, NgIf, MatButton]
})
export class TagsGridDialogComponent implements OnInit {

  @ViewChild('tagsGrid') tagsGrid: TagsGridComponent;
  hasEditAccess: boolean;

  constructor(public dialogRef: MatDialogRef<TagsGridDialogComponent>,
              public dialog: MatDialog,
              public authService: AuthService,
  ) {

  }

  ngOnInit(): void {
    this.hasEditAccess = this.authService.hasAccess([RolesEnum.Tags_Edit, RolesEnum.Tags_Delete]);
  }

  onNewTag() {
    const dialogRef = this.dialog.open(TagEditDialogComponent, {
      width: '300px',
    });

    dialogRef.afterClosed().subscribe(async (result: boolean) => {
      if (result) {
        await this.tagsGrid.loadData();
      }
    });
  }
}
